import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RegionDto } from '@medone/medonehp-api-client';

import { RootState } from '../../../../shared/store';
import { AdminState, initialState } from './models';
import { reducers as arrivingFromsReducers } from './slice.arriving-froms';
import { reducers as cqmCapabilityReducers } from './slice.cqm-capability';
import { reducers as cqmMeasureConfigurationReducers } from './slice.cqm-measure-configuration';
import { reducers as dsiInterventionsReducers } from './slice.dsi-interventions';
import { reducers as eventLogsReducers } from './slice.event-logs';
import { reducers as facilitiesReducers } from './slice.facilities';
import { reducers as hospiceCompaniesReducers } from './slice.hospice-intake-companies';
import { reducers as hospitalSystemsReducers } from './slice.hospital-systems';
import { reducers as patientTypesReducers } from './slice.patient-types';
import { reducers as returnToHospitalConfigReducers } from './slice.return-to-hospital-config';

export const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setError: (state: AdminState, action: PayloadAction<string>) => {
            state.errorMessage = action.payload;
        },

        resetState: (state: AdminState) => {
            state.currentArrivingFrom = null;
            state.currentFacility = null;
            state.currentHospitalSystem = null;
            state.currentPatientType = null;
            state.currentRegion = null;
        },

        setRegions: (state: AdminState, action: PayloadAction<RegionDto[]>) => {
            state.regions = action.payload;
            state.errorMessage = null;
        },

        setRegion: (state: AdminState, action: PayloadAction<RegionDto>) => {
            state.currentRegion = action.payload;
            state.errorMessage = null;
        },

        syncRegion: (state: AdminState, action: PayloadAction<RegionDto>) => {
            let newItems = [...state.regions];
            const index = state.regions.findIndex((x) => x.id === action.payload.id);

            if (index !== -1) {
                newItems = newItems.map((item) => {
                    if (item.id === action.payload.id) {
                        return { ...item, ...action.payload } as RegionDto;
                    }

                    return item;
                });
            } else {
                newItems.push(action.payload);
            }

            state.regions = newItems;

            if (state.currentRegion != null && state.currentRegion.id === action.payload.id) {
                state.currentRegion = action.payload;
            }
        },

        ...facilitiesReducers,
        ...patientTypesReducers,
        ...arrivingFromsReducers,
        ...eventLogsReducers,
        ...hospitalSystemsReducers,
        ...returnToHospitalConfigReducers,
        ...hospiceCompaniesReducers,
        ...cqmCapabilityReducers,
        ...cqmMeasureConfigurationReducers,
        ...dsiInterventionsReducers,
    },
});

export const selectError = (state: RootState) => state.admin.errorMessage;

export const { setRegions, setRegion, syncRegion, setEventLogFilter, setEventLogs } = adminSlice.actions;

export default adminSlice.reducer;
